export enum BackgroundView3dType {
  Terrain = 'terrain',
  Building = 'building',
}
